<footer>
    <div class="row">
        <div class="col-lg-3 logo">
            <a href="index.html">
               <img src="assets/images/logoB2BPie.png" class="logoPie" alt="logo FACeB2B">
          </a>
        </div>
 	      <div class="col-lg-3 col-sm-4">
          <span for="integracionFooter" class="h4" translate>
               pub.footer.faceb2b
          </span>
        <ul>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracioninvoice" target="_blank" translate>
                      pub.footer.wsIntegration
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracioninvoicingservice" target="_blank" translate>
                     pub.footer.wsIntegration2
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracionclients" target="_blank" translate>
                      pub.footer.wsIntegration3
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-lg-3 col-sm-4">
            <span class="h4" translate>
               pub.footer.utilities
            </span>
            <ul>
              <li>
                <a id="Onboarding" class="noEnResponsive" translate>pub.footer.UseGuide</a>
              </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/manualusuario" target="_blank" translate>
                      pub.footer.techRequirements
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/faqs" target="_blank" translate>
                     pub.footer.techRequirements2
                    </a>
                </li>
                <li>
                    <a href="https://ssweb.seap.minhap.es/ayuda/consulta/FACEB2B" target="_blank" translate>
                      pub.footer.support
                    </a>
                </li>
                <li>
                  <a routerLink="accesibilidad" routerLinkActive="active" translate>
                    pub.footer.accesibility
                  </a>
                </li>
            </ul>
        </div>
        <div class="col-lg-3 col-sm-4">
            <span class="h4"translate>
                pub.footer.links
            </span>
            <ul>
                <li>
                    <a href="http://dire.gob.es" target="_blank" translate>
                       pub.footer.dire
                    </a>
                </li><li>
                    <a href="http://face.gob.es" target="_blank" translate>
                        pub.footer.face
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/"  target="_blank" translate>
                        pub.footer.pae
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="subFooter" translate>
      pub.footer.subFooter
    </div>

      <div class="RGPD"><p>Los datos personales facilitados mediante el presente formulario serán tratados por la Secretaría General de Administración Digital con la finalidad de mantener información básica, para que las distintas aplicaciones de la Secretaría General de Administración Digital y de aquellos organismos, Administraciones Públicas y servicios privados que deseen hacer uso de dicha información puedan acceder a la misma respondiendo al artículo 14 de la ley 39/2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas. Podrá ejercer sus derechos de protección de datos ante el responsable del tratamiento. Antes de acceder al formulario debe leer la siguiente <a href="http://administracionelectronica.gob.es/PAe/FACeB2B_RGPD.pdf" target="_blank">información adicional sobre protección de datos personales</a></p></div>
</footer>



// WEBPACK FOOTER //
// ./src/app/app-public/pub-footer/pub-footer.component.html